import AuthService from '../../service';
const Contact = {
  getContact(page,search,sort_date,sort_branch){
    return AuthService.get(`/about/contact?`+
      `page=${page}` +
      `&sort_date=${sort_date}` +
      `&sort_branch=${sort_branch}` +
      `&search=${search}`
    );
  },
  showContact(id){
    return AuthService.get(`/about/contact/${id}`);
  },
  createContact(data){
    return AuthService.post(`/about/contact`,data);
  },
  updateContact(id,data){
    return AuthService.put(`/about/contact/${id}`,data);
  },
  deleteContact(id){
    return AuthService.delete(`/about/contact/${id}`);
  },
}
export default Contact
